export const statusOptions = [
  { value: 1, label: 'Active', bg: 'success' },
  { value: 0, label: 'Passive', bg: 'warning' },
  { value: 2, label: 'Completed', bg: 'info' },
  { value: 3, label: 'Deleted', bg: 'secondary' }
];
